import { types } from 'mobx-state-tree';


export default types.model('DocumentMetadata', {
    // Some of the system level fields get automatically added 
    // to the metadata by profile-service and are purposely excluded 
    // here as we can get them from the top level system fields of the doc.
});

